/* eslint-disable */
export default {
  unmute: 'Activar sonido',
  mute: 'Silenciar',
  keypad: 'Teclado',
  hold: 'Retener',
  onHold: 'En espera',
  park: 'Estacionar',
  stopRecord: 'Detener',
  record: 'Grabar',
  add: 'Agregar',
  transfer: 'Transferir',
  flip: 'Volteo',
  more: 'Acción de llamada',
  mergeToConference: 'Combinar',
  end: 'Finalizar',
  completeTransfer: 'Completar\ntransferencia',
} as const;

// @key: @#@"unmute"@#@ @source: @#@"Unmute"@#@
// @key: @#@"mute"@#@ @source: @#@"Mute"@#@
// @key: @#@"keypad"@#@ @source: @#@"Keypad"@#@
// @key: @#@"hold"@#@ @source: @#@"Hold"@#@
// @key: @#@"onHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"park"@#@ @source: @#@"Park"@#@
// @key: @#@"stopRecord"@#@ @source: @#@"Stop"@#@
// @key: @#@"record"@#@ @source: @#@"Record"@#@
// @key: @#@"add"@#@ @source: @#@"Add"@#@
// @key: @#@"transfer"@#@ @source: @#@"Transfer"@#@
// @key: @#@"flip"@#@ @source: @#@"Flip"@#@
// @key: @#@"more"@#@ @source: @#@"Call Actions"@#@
// @key: @#@"mergeToConference"@#@ @source: @#@"Merge"@#@
// @key: @#@"end"@#@ @source: @#@"End"@#@
// @key: @#@"completeTransfer"@#@ @source: @#@"Complete\nTransfer"@#@
